import { AuthGuard, CanDeactivateGuard } from "@dis/auth";
import { JtmsRoutes, tablesLayout, groupOverview } from "../core/routing/route-data";

// Assembly detail waits for the assemblies' Data Connect migration (today they key on the Sheets assembly number).
export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "engineering" },
    children: [
      groupOverview(() => import("../feature/overviews/engineering-overview").then((m) => m.EngineeringOverview)),
      {
        path: "parts",
        children: [
          {
            path: "",
            pathMatch: "full",
            loadComponent: tablesLayout,
            children: [
              {
                path: "",
                data: { navOrder: 1 },
                loadComponent: () => import("../feature/parts/parts-table/parts-table").then((m) => m.PartsTable),
                title: "Parts",
              },
            ],
          },
          {
            path: "new",
            canDeactivate: [CanDeactivateGuard],
            loadComponent: () =>
              import("../jtms/6_parts/part-creator-container/part-creator-container.component").then(
                (m) => m.PartCreatorContainerComponent
              ),
            title: "New Part",
          },
          {
            // One revision, by its Part row id. Legacy /parts/:partNumber still opens a part number's first revision.
            path: ":partId",
            canDeactivate: [CanDeactivateGuard],
            loadComponent: () =>
              import("../feature/parts/part-container/part-container.component").then((m) => m.PartContainerComponent),
            title: "Part",
          },
        ],
      },
      {
        path: "assemblies",
        children: [
          {
            path: "",
            pathMatch: "full",
            loadComponent: tablesLayout,
            children: [
              {
                path: "",
                data: { navOrder: 2 },
                loadComponent: () =>
                  import("../feature/assembly/assembly-table/assembly-table.component").then(
                    (m) => m.AssemblyTableComponent
                  ),
                title: "Assemblies",
              },
            ],
          },
          {
            path: "new",
            canDeactivate: [CanDeactivateGuard],
            loadComponent: () =>
              import("../feature/assembly/forms/create-assembly-form-container/create-assembly-form-container.component").then(
                (m) => m.CreateAssemblyFormContainer
              ),
            title: "New Assembly",
          },
        ],
      },
      {
        path: "connections",
        children: [
          {
            path: "",
            pathMatch: "full",
            loadComponent: tablesLayout,
            children: [
              {
                path: "",
                data: { navOrder: 3 },
                loadComponent: () =>
                  import("../feature/connections/connection-table/connection-table").then((m) => m.ConnectionTable),
                title: "Connections",
              },
            ],
          },
          {
            path: "mates",
            loadComponent: () =>
              import("../feature/connections/connection-mates/connection-mates").then((m) => m.ConnectionMates),
            title: "Connection Mates",
          },
        ],
      },
      {
        path: "tool-families",
        loadComponent: tablesLayout,
        children: [
          {
            path: "",
            data: { navOrder: 4 },
            loadComponent: () => import("../feature/tool-families/tool-families").then((m) => m.ToolFamilies),
            title: "Tool Families",
          },
        ],
      },
      {
        // Shared with the elements app.
        path: "tool-specs",
        data: { navOrder: 5 },
        loadComponent: () =>
          import("../../../../elements/src/app/tool-grid-editable/tool-grid").then((m) => m.ToolGridEditable),
        title: "Tool Specs",
      },
    ],
  },
] satisfies JtmsRoutes;
